import React, { type RefObject } from "react";
export function useScrollToActiveElement(ref: RefObject<HTMLElement | null>, activeIndex: number, idPrefix: string) {
  React.useEffect(() => {
    const container = ref.current;
    const activeElementId = `${idPrefix}-${activeIndex}`;
    const activeElement = container?.querySelector(`#${activeElementId}`);
    if (!container || !activeElement) {
      return;
    }
    const containerRect = container.getBoundingClientRect();
    const activeElementRect = activeElement.getBoundingClientRect();
    let newScrollLeft = container.scrollLeft;
    let shouldScroll = false;
    if (activeElementRect.left < containerRect.left) {
      newScrollLeft += activeElementRect.left - containerRect.left;
      shouldScroll = true;
    } else if (activeElementRect.right > containerRect.right) {
      newScrollLeft += activeElementRect.right - containerRect.right;
      shouldScroll = true;
    }
    if (shouldScroll) {
      container.scrollTo({
        left: newScrollLeft,
        behavior: "smooth"
      });
    }
  }, [activeIndex]); // eslint-disable-line react-hooks/exhaustive-deps
}